export type CronMacro = {
  name: string;
  value: string;
};

export const cronMacros: CronMacro[] = [
  { name: 'Every 15 Minutes', value: '*/15 * * * *' },
  { name: 'Every 30 Minutes', value: '*/30 * * * *' },
  { name: 'Every Hour', value: '0 * * * *' },
  { name: 'Every 2 Hours', value: '0 */2 * * *' },
  { name: 'Every 4 Hours', value: '0 */4 * * *' },
  { name: 'Every 6 Hours', value: '0 */6 * * *' },
  { name: 'Every 12 Hours', value: '0 */12 * * *' },
  { name: 'Every Day', value: '0 0 * * *' },
  { name: 'Every Week', value: '0 0 * * 0' },
  { name: 'Every Month', value: '0 0 1 * *' },
  { name: 'Every Year', value: '0 0 1 1 *' },
];
